import type {
  FILTERED_JOB_LIST,
  FILTERED_JOB_PAYLOAD,
  FILTERED_JOB_SELECTED,
} from 'src/types/crm';

import type {Dispatch, GetState, ThunkAction} from 'src/reducers';
import type {ApiOptions, ApiPostOptions} from 'src/utils/redux-api';

import {thunkify as flow} from 'src/utils/thunks';
import * as reduxApi from 'src/utils/redux-api';

import {key, fetching} from 'src/utils/redux';


const POST_API_OPTIONS: ApiPostOptions = {
  apiPath: '/trmapi',
};

export const GET_FILTERED_JOB = 'get-filtered-job';
export const STORE_JOB_FILTERS = 'store-job-filters';

export type GetFilteredJobListAction = {
  type: typeof GET_FILTERED_JOB;
  payload: FILTERED_JOB_LIST;
};

export type StoreJobFiltersAction = {
  type: typeof STORE_JOB_FILTERS;
  payload: {
    selectedFilters: FILTERED_JOB_PAYLOAD;
    rawFilteredSelected: FILTERED_JOB_SELECTED;
    selectedJobStatuses: string[];
    searchedText: string;
    isMyJobSelected: boolean;
  };
};

export type CrmFilteredJobActions =
  | GetFilteredJobListAction
  | StoreJobFiltersAction;

export const updateFilteredList = (
  payload: FILTERED_JOB_LIST,
): GetFilteredJobListAction => ({
  type: GET_FILTERED_JOB,
  payload,
});

export const storeJobFilters = (
  payload: StoreJobFiltersAction['payload'],
): StoreJobFiltersAction => ({
  type: STORE_JOB_FILTERS,
  payload,
});

export const getFilteredJob: (
  filteredPayload: FILTERED_JOB_PAYLOAD,
) => ThunkAction<void> = flow(
  key(
    (filteredPayload) =>
      `crm/filtered-job-list/${JSON.stringify(filteredPayload)}`,
  ),
  fetching(),
)((filteredPayload: FILTERED_JOB_PAYLOAD) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `/api/filtered-jobs`,
      {
        ...filteredPayload,
      },
      {},
      POST_API_OPTIONS,
    ),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: FILTERED_JOB_LIST) => void' is not assignable to parameter of type '(value: unknown) => void | PromiseLike<void>'.
    (response: FILTERED_JOB_LIST) => {
      dispatch(updateFilteredList(response));
    },
    (error) => {
      // Error handling
    },
  );
});
